/*
 * Created by tomnotcat on 2023/03/01.
 */
import { flags_map } from './flag-icons-map';
import * as Helper from "../../utils/Helper";

class FlagIconsHelper {
    constructor() {
    }

    getFlagIconUrl = (country) => {
        const c = country ? country.toLowerCase() : 'cn';
        var iconName = flags_map[c];
        if (!iconName) {
            iconName = 'xx.png';
        }
        return Helper.convertToAbsoluteUrl(`~/fs/images/chinesepark/flag-icons/${iconName}`);
    };

    getFlagIconSource = (country) => {
        const url = this.getFlagIconUrl(country);
        return {uri: url};
    };
}

export default new FlagIconsHelper();
